/**
 * Utilitaires de validation avec regex
 */

/**
 * Valide une adresse email
 * @param {string} email - L'adresse email à valider
 * @returns {boolean} - true si l'email est valide, false sinon
 */
export const validateEmail = (email) => {
  if (!email || typeof email !== 'string') return false;
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email.trim());
};

/**
 * Valide un numéro de téléphone marocain
 * Accepte les formats:
 * - 06XXXXXXXX, 07XXXXXXXX
 * - Avec espaces, tirets ou parenthèses
 * @param {string} phone - Le numéro de téléphone à valider
 * @returns {boolean} - true si le numéro est valide, false sinon
 */
export const validatePhone = (phone) => {
  if (!phone || typeof phone !== 'string') return false;
  // Nettoyer le numéro (retirer espaces, tirets, parenthèses)
  const cleaned = phone.replace(/[\s\-().]/g, '');
  // Accepte uniquement 06XXXXXXXX ou 07XXXXXXXX
  const phoneRegex = /^0[6-7]\d{8}$/;
  return phoneRegex.test(cleaned);
};

/**
 * Valide un mot de passe
 * Critères : Au moins 8 caractères, 1 majuscule, 1 minuscule, 1 chiffre
 * @param {string} password - Le mot de passe à valider
 * @returns {boolean} - true si le mot de passe est valide, false sinon
 */
export const validatePassword = (password) => {
  if (!password || typeof password !== 'string') return false;
  // Au moins 8 caractères, 1 majuscule, 1 minuscule, 1 chiffre
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
  return passwordRegex.test(password);
};

/**
 * Formate un numéro de téléphone pour l'affichage
 * @param {string} phone - Le numéro de téléphone
 * @returns {string} - Le numéro formaté
 */
export const formatPhone = (phone) => {
  if (!phone) return '';
  const cleaned = phone.replace(/[\s\-().]/g, '');
  
  // Si commence par +212
  if (cleaned.startsWith('+212')) {
    const number = cleaned.substring(4);
    return `+212 ${number.substring(0, 1)} ${number.substring(1, 3)} ${number.substring(3, 5)} ${number.substring(5)}`;
  }
  
  // Si commence par 212
  if (cleaned.startsWith('212')) {
    const number = cleaned.substring(3);
    return `+212 ${number.substring(0, 1)} ${number.substring(1, 3)} ${number.substring(3, 5)} ${number.substring(5)}`;
  }
  
  // Si commence par 0
  if (cleaned.startsWith('0')) {
    return `${cleaned.substring(0, 2)} ${cleaned.substring(2, 4)} ${cleaned.substring(4, 6)} ${cleaned.substring(6)}`;
  }
  
  return phone;
};

/**
 * Messages d'erreur de validation
 */
export const validationMessages = {
  email: {
    required: "L'adresse email est requise",
    invalid: "L'adresse email n'est pas valide (exemple: utilisateur@domaine.com)"
  },
  phone: {
    required: "Le numéro de téléphone est requis",
    invalid: "Le numéro de téléphone n'est pas valide (exemple: 06XXXXXXXX ou 07XXXXXXXX)"
  },
  password: {
    required: "Le mot de passe est requis",
    invalid: "Le mot de passe doit contenir au moins 8 caractères, une majuscule, une minuscule et un chiffre"
  }
};
